<template>
  <div>
    <div class="box box-solid">
      <div class="box-body">
        <table class="table">
          <thead>
            <tr>
              <th>Dosen</th>
              <th>Nilai</th>
              <th>Uraian Revisi</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in data"
              :key="item.id"
            >
              <td>{{ item.nama }}</td>
              <td>
                <span class="fa fa-check text-success" v-if="item.nilai !== null"></span>
                <span class="fa fa-minus text-muted" v-else></span>
              </td>
              <td>
                <span class="fa fa-check text-success" v-if="item.uraian_revisi !== null"></span>
                <span class="fa fa-minus text-muted" v-else></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="box box-solid">
      <div class="box-body">
        <p><strong>Status Ujian</strong></p>
        <div class="radio">
          <label>
            <input type="radio" id="saya" value="L" v-model="status">
            Lulus
          </label>
        </div>
        <div class="radio">
          <label>
            <input type="radio" id="pembimbing" value="M" v-model="status">
            Mengulang
          </label>
        </div>
        <p></p>
        <button
          @click="save()"
          class="btn btn-primary">Simpan</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  props: ['id', 'status_kegiatan_id'],
  data: () => ({
    status: null,
    data: [],
  }),
  methods: {
    async loadNilai() {
      let response = await axios.get('/koordinasi-ujian/nilai/' + this.id)
      this.data = response.data
    },
    async save() {
      try {
        await axios.post('/koordinasi-ujian/status/' + this.id, {
          status_kegiatan_id: this.status,
        })
        window.$.notify({
          // options
          message: 'Status ujian berhasil disimpan.'
        },{
          // settings
          type: 'success',
          delay: 1250,
          placement: {
            from: "top",
            align: "center"
          },
        });
      } catch(e) {
        window.$.notify({
          // options
          message: 'Tidak dapat menyimpan status'
        },{
          // settings
          type: 'warning',
          delay: 1250,
          placement: {
            from: "top",
            align: "center"
          },
        });
      }
    },
  },
  created() {
    this.status = this.status_kegiatan_id
    this.loadNilai()
  },
  mounted() {
    setInterval(() => {
      this.loadNilai()
    }, 5000)
  },
}
</script>